import { theme } from "../../theme/theme";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";

export const styles = ({spacing, palette}: Theme) => createStyles({

    buttons: {
        marginTop: spacing.unit * 3,
        marginBottom: spacing.unit * 3,
    },
    button: {
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 0,
        textTransform: "initial",
        color: palette.primary.main,
        "&:hover": {
            backgroundColor: palette.primary[200],            
        },
        "& .active": {            
            backgroundColor: `${palette.primary.main} !important`,
            color: `${palette.primary.contrastText} !important`
        }
    },
    buttonActive: {
        fontWeight: 600,
        backgroundColor: palette.primary.main,
        color: palette.primary.contrastText
    },
    margin: {
        marginTop: spacing.unit * 4
    },
    active: {
        position: "absolute",
        right: spacing.unit
    },
    loading: {
        margin: "7px"
    },
    printIcons: {
        marginRight: spacing.unit
    },
    printButton: {
        textTransform: "inherit",
        fontWeight: 300
    }
});


// WEBPACK FOOTER //
// ./src/components/PopinQuotationActions/PopinQuotationActions.style.tsx